<template>
   <div class="banner_bottom_agile_info">
	<div class="container">
	   <div class="agile-contact-grids dir-rtl">
				<div class="agile-contact-left">
				</div>
				<div class="clearfix"> </div>
			</div>
       </div>
	</div>
</template>

<script>
export default {
name:"MessagePopup"
}
</script>

<style>

</style>